<template>
  <div class="content if-profile">
    <PulseLoader :loading="setLoading" :class="{hide: !setLoading}" quote="Action is the foundational key to all success" author="Pablo Picasso" profession="Spanish Painter" img="picasso.jpg"></PulseLoader>
    <div class="md-layout finanical-insights-body">
      <CPHeader :headerData="ifInfo ? ifInfo : ''"/>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <div class="navbar md-toolbar md-transparent md-elevation-4 p-0">
          <div class="md-toolbar-row p-0">
            <nav-tabs-card class="m-0">
                <template slot="content">
                    <div class="md-layout">
                      <md-card class="if_card">
                        <md-card-header>
                          Terms
                        </md-card-header>
                        <!-- <div class="md-toolbar-row map-box-title">
                            <div class="md-layout">
                                <md-card-header class="md-card-header-icon">
                                    <h1 class="md-title text-left profile-title">
                                      Terms
                                    </h1>
                                </md-card-header>
                            </div>
                        </div> -->
                        <md-card-content>
                          <div class="md-layout table-box-margin p-4">
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <md-card class="md-card-profile">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                      Industry Financial Insight Terms
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="extra_space">
                                    <!-- <h1 class="md-body-2 text-left">
                                      <b>INDUSTRY FINANCIAL INSIGHT TERMS</b>
                                    </h1> -->
                                      <p>Industry peer group percentage averages are applied to the company's estimatedrevenue.</p>
                                      <ul>
                                        <li>Gross Margin:<p> Business Revenue minus Cost of Sales</p></li>
                                        <li>Officer/Owner's Compensation:<p>Total wage compensation for services of company officers</p></li>
                                        <li>Depreciation:<p>Current portion of non-cash depreciation-amortization-depletion</p></li>
                                        <li> Operating Expenses:<p>Discretionary Expenses (excludes Cost of Sales and Interest Paid)</p></li>
                                        <li>After-Tax Net Profit:<p>Net Profit after payment of income taxes</p></li>
                                        <li>Owner Earnings:<p>Officers Compensation+Net Profit+Depreciation</p></li>
                                        <li> Net Worth/Assets:<p> Net Worth as a percent of Total Assets</p></li>
                                        <li> Accounts Receivable: Total Assets:<p> Short-term receivables as a percent of Total Assets</p></li>
                                        <li> Accounts Payable:TL& NW:<p>Short-term receivables as a percent of Total Liabilities+Net Worth</p></li>
                                        <li> Days Payable: <p> 365/(Cost of Sales/Accounts Payable ratio)</p></li>
                                        <li> Days Receivable: <p> 365/(Business Revenue/Receivables)</p></li>
                                        <li>Current Ratio:<p>Current Assets/Current Liabilities</p></li>
                                        <li>Interest Coverage:<p>[Earnings before Interest, Taxes Due, DepreciationAmortization]/Interest expense</p></li>
                                        <li>Current Liabilities:<p>Net Worth: Current Liabilities/Net Worth</p></li>
                                        <li>Total Liabilities: Net Worth:<p>Total liabilities/Net Worth</p></li>
                                        <li>Modified Z-Score:<p> A modified form of the Altman Z-Score which evaluates default risk</p></li>
                                        <li>Net Working Capital: Revenue: <p>(Current Assets-Current Liabilities)/Business Revenue</p></li>
                                        <li>Accounts Payable:Revenue:<p>Accounts Payable/Business Revenue</p></li>
                                        <li>Loans-Notes Payable:Net Worth:<p>Loans-Notes Payable/Net Worth</p></li>
                                        <!-- <h1 class="md-body-2 text-left">
                                          INDUSTRY FINANCIAL INSIGHT TERMS
                                        </h1> -->
                                        <!-- <div> -->
                                        <li>Bizminer Valuations Value basis derived from projected company sales; peer group
                                          average earnings %; and industry valuation multiples. Median ranges reflect a range of
                                          market conditions and business performance at this revenue scale.</li> <br>
                                        <li>You should not use Bizminer Valuations in place of a professional valuation or as the
                                          basis of any specific business-related or other financial transaction; nor to secure a
                                          business or personal loan.
                                        </li><br>
                                        <li>Owner Earnings (Cash Flow) Approach:<p> Revenue/Owner Earnings market valuation approach</p></li>
                                        <li>Sales Approach:<p> Revenue/Annual Sales market value approach</p></li>
                                        <li>Median and Quartiles: Median:<p> the point at which 50% of a sample is above and 50% of</p></li>
                                        <li>the same below the value.</li>
                                        <li>Quartile 1 lies at the mid-point between the median and the lowest value; Quartile 3</li>
                                        <li>between the median and the highest value</li>
                                      </ul>
                                      <!-- </div> -->
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <md-card class="md-card-profile">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                      Industry Analysis Insight Terms
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="extra_space">
                                    <!-- <h1 class="md-body-2 text-left">
                                      <b> MARKET ANALYSIS INSIGHT TERMS</b>
                                    </h1> -->
                                    <ul>
                                    <li>Market Area:<p>The selected market parameters for this industry. Where there are at least
                                        five identified industry establishments, default market parameters are:</p>
                                    </li>
                                    <li>15 MILE RADIUS
                                      <p>44-45 Retail Trade<br>
                                      72 Accommodation-Food Services<br>
                                      811-812 Other Services</p>
                                    </li>
                                    <li>METRO
                                      <p>23 Construction<br>
                                      42 Wholesale Trade<br>
                                      48-49 Transportation-Warehousing<br>
                                      51 Information<br>
                                      52 Finance and Insurance<br>
                                      53 Real Estate- Rental and Leasing<br>
                                      54 Professional-Scientific-Technical Services<br>
                                      56 Administrative-Support-Waste-Remediation<br>
                                      61 Educational Services<br>
                                      62 Health Care-Social Assistance<br>
                                      71 Arts-Entertainment- Recreation<br>
                                      813 Religious-Grantmaking-Civic-Professional and Similar Organizations</p>
                                    </li>
                                    <li>US-NATIONAL
                                      <p>11 Agriculture-Forestry-Fishing-Hunting<br>
                                      21 Mining-Quarrying- Oil &amp; Gas Extraction<br>
                                      22 Utilities<br>
                                      31-32-33 Manufacturing<br>
                                      55 Management- Companies &amp; Enterprises</p>
                                    </li>
                                      <li>Industry Map:<p>Displays the closest operations in the same industry as the selected firm</p></li>
                                      <li>Competitors:<p> The number of same-industry operations within the market area.</p></li>
                                      <li>Industry Market Sales Volume:<p>Aggregate industry market sales</p></li>
                                      <li>Average Site Sales:<p> Average annual revenue of industry market operations in the market area.</p></li>
                                      <li>Average Small Business Sales:<p>Average annual sales of single site firms with 25employees in the market</p></li>
                                      <li>Firm Sales Rank:<p> Sales rank based on this location's estimated revenue among all sameindustry market operations</p></li>
                                      <li>US and Market Sales per Household:<p> Sales per household using the US as a comparisonbasis for the local market or, if a national market, displaying that value.</p></li>
                                      <li>Per Capita Income:<p> Average area income per person</p></li>
                                      <li>Median Household Income:<p> Median (mid-point) area income per household</p></li>
                                    </ul>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
              </template>
            </nav-tabs-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Collapse, PulseLoader } from '@/components';
import { NavTabsCard } from "@/components";
import { mapState } from 'vuex';
import CPHeader from "./_partials/CPHeader.vue";


export default {
  components: {
    NavTabsCard,
    // Collapse,
    PulseLoader,
    CPHeader
  },
  data() {
    return {
      filtered_company_profile_list: []
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),
    ifInfo() {
      return this.$store.getters.profileInfo;
    },
    getFormattedData() {
      let a = {};

      a.company = this.ifInfo.companyTitle;
      a.original_name = "";
      a.infogroup = this.ifInfo.locnum;
      a.unique_id = "";
      a.street = this.ifInfo.street?this.ifInfo.street:"";
      a.city = this.ifInfo.city?this.ifInfo.city:"";
      a.state = this.ifInfo.state?this.ifInfo.state:"";
      a.zip = this.ifInfo.zip?this.ifInfo.zip:"";
      a.industry_code = this.ifInfo.naics;
      a.industry = this.ifInfo.industry;


      let b = this.ifInfo.businessOwner?this.ifInfo.businessOwner.split(',')[0]:"";
      a.contact_first = b.split(' ')[0];
      a.contact_last = b.split(' ')[1];
      a.phone = this.ifInfo.businessPhone?this.ifInfo.businessPhone:"";
      a.url = this.ifInfo.businessURL?this.ifInfo.businessURL:"";
      let g = this.ifInfo.release_id.replace("_","-01-20");
      const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];


      a.operation_details = monthNames[new Date(g).getMonth()] + " " + new Date(g).getFullYear();
      a.location_annual_sales = this.ifInfo.bizop['Location Sales'][0];
      a.location_employment = this.ifInfo.bizop['Employment'][0]
      a.corporation_annual_sales = this.ifInfo.bizop['Corporate Sales'][0]
      a.corporation_employment = this.ifInfo.bizop['Corporate Employment'][0]

      a.market_insights_date = monthNames[new Date(g).getMonth()] + " " + new Date(g).getFullYear();
      a.market_industry_code = this.ifInfo.IMRnaics
      a.market_industry = this.ifInfo.IMRindustry
      a.market_area = this.ifInfo['MR']['area']

      a.industry_operations = this.ifInfo['MR']['main']['Industry Operations']
      a.location_sales_rank = this.ifInfo['MR']['main']['Business Sales Rank']
      a.industry_market_sales_volume = this.ifInfo['MR']['main']['Annual Market Sales Volume']
      a.average_site_sales = this.ifInfo['MR']['main']['Average Site Sales']
      a.average_small_business_sales = this.ifInfo['MR']['main']['Average Small Business Sales']

      a.industry_market_sales_per_person = this.ifInfo['MR']['penetration']['Market Sales per Person']
      a.us_industry_sales_per_person = this.ifInfo['MR']['penetration']['US Sales per Person']
      a.opportunity_index_person = this.ifInfo['MR']['penetration']['Opportunity Index Person']
      a.industry_market_sales_per_household = this.ifInfo['MR']['penetration']['Market Sales per Household']
      a.us_industry_sales_per_household = this.ifInfo['MR']['penetration']['US Sales per Household']
      a.opportunity_index_household = this.ifInfo['MR']['penetration']['Opportunity Index Household']

      a.market_area_population = this.ifInfo['MR']['income']['Population']
      a.market_area_households = this.ifInfo['MR']['income']['Households']
      a.per_capita_income = this.ifInfo['MR']['income']['Per Capita Income']
      a.mediab_hh__income = this.ifInfo['MR']['income']['Median HH Income']
      a.business_values_insights_date = monthNames[new Date(g).getMonth()] + " " + new Date(g).getFullYear();

      a.sales_approach_quartile1 =  this.ifInfo.multiples.data['Quartile 1']['sales']
      a.sales_approach_median =  this.ifInfo.multiples.data['Median']['sales']
      a.sales_approach_quartile3 =  this.ifInfo.multiples.data['Quartile 3']['sales']
      a.earnings_approach_quartile1 =  this.ifInfo.multiples.data['Quartile 1']['earnings']
      a.earnings_approach_median =  this.ifInfo.multiples.data['Median']['earnings']
      a.earnings_approach_quartile3 =  this.ifInfo.multiples.data['Quartile 3']['earnings']

      a.if_industry_code =  this.ifInfo.naics
      a.if_industry_name =  this.ifInfo.industry
      a.if_industry_sales_class =  this.ifInfo.IF['sales-class']
      a.financial_insights_date =  this.ifInfo.IF['period']

      a.gross_margin_percentage =  this.ifInfo.IF.spend['Gross Margin'].percentage;
      a.office_owner_compensation_percentage =  this.ifInfo.IF.spend['Officer-Owner-Compensation'].percentage;
      a.depreciation_percentage =  this.ifInfo.IF.spend['Depreciation'].percentage;
      a.operating_expense_percentage =  this.ifInfo.IF.spend['Operating Expenses'].percentage;
      a.operating_income_percentage =  this.ifInfo.IF.spend['Operating Income'].percentage;
      a.after_tax_net_profit_percentage =  this.ifInfo.IF.spend['After Tax Net Profit'].percentage;
      a.owner_earnings_percentage =  this.ifInfo.IF.spend['Owner Earnings'].percentage;
      a.account_receivable_percentage =  this.ifInfo.IF.spend['Accounts Receivable: Total Assets'].percentage;
      a.account_payable_percentage =  this.ifInfo.IF.spend['Accounts Payable: TLNW'].percentage;
      a.net_worth_assets_percentage =  this.ifInfo.IF.spend['Net Worth: Assets'].percentage;

      a.gross_margin_dollar =  this.ifInfo.IF.spend['Gross Margin'].dollar;
      a.office_owner_compensation_dollar =  this.ifInfo.IF.spend['Officer-Owner-Compensation'].dollar;
      a.depreciation_dollar =  this.ifInfo.IF.spend['Depreciation'].dollar;
      a.operating_expense_dollar =  this.ifInfo.IF.spend['Operating Expenses'].dollar;
      a.operating_income_dollar =  this.ifInfo.IF.spend['Operating Income'].dollar;
      a.after_tax_net_profit_dollar =  this.ifInfo.IF.spend['After Tax Net Profit'].dollar;
      a.owner_earnings_dollar =  this.ifInfo.IF.spend['Owner Earnings'].dollar;
      a.account_receivable_dollar =  this.ifInfo.IF.spend['Accounts Receivable: Total Assets'].dollar;
      a.account_payable_dollar =  this.ifInfo.IF.spend['Accounts Payable: TLNW'].dollar;
      a.net_worth_assets_dollar =  this.ifInfo.IF.spend['Net Worth: Assets'].dollar;

      a.account_payable_revenue = this.ifInfo.IF.benchmarks['Accounts Payable: Revenue'];
      a.current_ratio = this.ifInfo.IF.benchmarks['Current Ratio'];
      a.days_payable = this.ifInfo.IF.benchmarks['Days Payable'];
      a.net_working_capital_revenue = this.ifInfo.IF.benchmarks['Net Working Capital Revenue'];
      a.days_receivable = this.ifInfo.IF.benchmarks['Days Receivable'];
      a.interest_coverage = this.ifInfo.IF.benchmarks['Interest Coverage'];
      a.current_liabilites = this.ifInfo.IF.benchmarks['Current Liabilities: NW'];
      a.loans_notes = this.ifInfo.IF.benchmarks['Loans‐Notes Payable: Net Worth'];
      a.modified_z = this.ifInfo.IF.benchmarks['Modified Z Score'];
      a.total_liabilities = this.ifInfo.IF.benchmarks['Total Liabilties: Net Worth'];

      Object.values(a).forEach((element,index) => {
        let b ="";
        if(element && element.includes(',')){
          b = element.replace(/,/g, ".");
        }else {
          b = element;
        }
        this.filtered_company_profile_list.push(b);
      })
      return this.filtered_company_profile_list;
    },
    getCsvData() {
      let csvData = [
        [
          'Company',
          'Original Name',
          'Infogroup ID',
          'Unique ID',
          'Street',
          'City',
          'State',
          'Zip',
          'Industry Code',
          'Industry',
          'Contact First',
          'Contact Last',
          'Phone',
          'URL',
          'Operation Detail Release',
          'Location Annual Sales',
          'Location Employment',
          'Corporate Annual Sales',
          'Corporate Employment',
          'Market Insights Date',
          'Market Industry Code',
          'Market Industry',
          'Market Area',
          'Industry Operations',
          'Location Sales Rank',
          'Industry Market Sales Volume',
          'Average Site Sales',
          'Average Small Business Sales',
          'Industry Market Sales per Person',
          'US Industry Sales per Person',
          'Opportunity Index',
          'Industry Market Sales per Household',
          'US Industry Sales per Household',
          'Opportunity Index',
          'Market Area Population',
          'Market Area Households',
          'Per Capital Income',
          'Median Household Income',
          'Business Value Insights Date',
          'Sales Approach Quartile1',
          'Sales Approach Median',
          'Sales Approach Quartile3',
          'Earnings Approach Quartile1',
          'Earnings Approach Median',
          'Earnings Approach Quartile3',
          'IF Industry code',
          'IF Industry name',
          'IF Sales class',
          'Financial Insights Date',
          'Gross Margin %',
          'Officer-Owner Compensation %',
          'Depreciation %',
          'Operating Expense %',
          'Operating Income %',
          'After Tax Net Profit %',
          'Owner Earnings %',
          'Accounts Receivable/Total Assets %',
          'Accounts Payable/TLNW %',
          'Net Worth/Assets %',
          'Gross Margin $',
          'Officer-Owner Compensation $',
          'Depreciation $',
          'Operating Expense $',
          'Operating Income $',
          'After Tax Net Profit $',
          'Owner Earnings $',
          'Accounts Receivable/Total Assets $',
          'Accounts Payable/TLNW $',
          'Net Worth/Assets $',
          'Accounts Payable/Revenue',
          'Current Ratio',
          'Days Payable',
          'Net Working Capital/Revenue',
          'Days Receivable',
          'Interest Coverage',
          'Current Liabilities/Net Worth',
          'Loans Notes Payable/Net Worth',
          'Modified Z Score',
          'Total Liabilties/Net Worth'
        ],
      ]

      csvData.push(this.getFormattedData);
      return csvData;
    },
    setLoading(){
      return !this.ifInfo;
    }
  },


  methods: {
    switchView: function (type) {
      this.view = type;
    },
     numberWithPoints(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else if(x === null){
        return x;
      }else
      {
        return x.replace(/,/g, '.');
      }
    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += "\n";
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Company Profile.csv';
      anchor.click();
    },
  },
};
</script>
<style lang="scss">

</style>
